import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [isSettingPassword, setIsSettingPassword] = useState(false);
  const [config, setConfig] = useState({
    siteTitle: '📌 카드 페이지 템플릿',
    siteTitleEmoji: '📌',
    adsenseCode: '',
    tabs: [],
  });

  // 인증 확인
  useEffect(() => {
    const savedPassword = localStorage.getItem('adminPassword');
    const sessionAuth = sessionStorage.getItem('adminAuth');

    // 비밀번호가 없으면 기본 비밀번호 설정
    if (!savedPassword) {
      localStorage.setItem('adminPassword', 'mcp1234');
    }

    if (sessionAuth === 'true') {
      // 세션에 인증 정보가 있으면 통과
      setIsAuthenticated(true);
    }
  }, []);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    const savedPassword = localStorage.getItem('adminPassword');

    // 비밀번호 확인
    if (password === savedPassword) {
      sessionStorage.setItem('adminAuth', 'true');
      setIsAuthenticated(true);
    } else {
      alert('비밀번호가 틀렸습니다.');
      setPassword('');
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuth');
    setIsAuthenticated(false);
    setPassword('');
    navigate('/');
  };

  const handleResetPassword = () => {
    if (window.confirm('비밀번호를 재설정하시겠습니까?')) {
      const newPassword = prompt('새 비밀번호를 입력하세요 (최소 4자):');
      if (newPassword && newPassword.length >= 4) {
        localStorage.setItem('adminPassword', newPassword);
        alert('비밀번호가 변경되었습니다!');
      } else if (newPassword !== null) {
        alert('비밀번호는 최소 4자 이상이어야 합니다.');
      }
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    
    // 백엔드 API에서 설정 가져오기
    const fetchConfig = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || '';
        const response = await fetch(`${apiUrl}/api/config`);
        if (response.ok) {
          const data = await response.json();
          setConfig(data);
        } else {
          throw new Error('API 요청 실패');
        }
      } catch (error) {
        console.error('설정 로드 실패:', error);
        // API 실패 시 localStorage에서 가져오기
        const savedConfig = localStorage.getItem('siteConfig');
        if (savedConfig) {
          setConfig(JSON.parse(savedConfig));
        } else {
          // 기본 데이터 로드
          const defaultConfig = {
        siteTitle: '📌 카드 페이지 템플릿',
        siteTitleEmoji: '📌',
        adsenseCode: '',
        tabs: [
          {
            id: 'guide',
            label: '가이드',
            path: '/guide',
            title: '가이드 페이지',
            description: ['이 템플릿을 원하는 주제로 커스터마이징하세요.', 'App.js 파일에서 제목, 설명, 카드 내용을 모두 수정할 수 있습니다.'],
            visible: true,
            blocks: [
              {
                subtitle: '시작하기 전에 알아야 할 것들',
                cards: [
                  { emoji: '📚', title: '첫 번째 카드', description: '여기에 설명을 입력하세요', link: 'https://example.com', bgColor: '#74b9ff' },
                  { emoji: '🎯', title: '두 번째 카드', description: '카드 내용을 자유롭게 수정하세요', link: 'https://example.com', bgColor: '#e17055' },
                ],
              },
            ],
          },
          {
            id: 'recommend',
            label: '추천',
            path: '/recommend',
            title: '추천 페이지',
            description: ['새로운 페이지를 만들 수 있습니다.'],
            visible: true,
            blocks: [
              {
                subtitle: '추천 항목',
                cards: [
                  { emoji: '🌟', title: '추천 1', description: '이 페이지의 내용도 자유롭게 수정하세요', link: 'https://example.com', bgColor: '#6c5ce7' },
                ],
              },
            ],
          },
        ],
      };
      setConfig(defaultConfig);
      localStorage.setItem('siteConfig', JSON.stringify(defaultConfig));
        }
      }
    };
    
    fetchConfig();
  }, [isAuthenticated]);

  const handleSave = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/api/config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(config),
      });
      
      if (response.ok) {
        // localStorage에도 저장 (캐시)
        localStorage.setItem('siteConfig', JSON.stringify(config));
        alert('저장되었습니다! 모든 브라우저에서 동일한 설정이 표시됩니다.');
        // 페이지 새로고침하여 변경사항 반영
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      } else {
        throw new Error('저장 실패');
      }
    } catch (error) {
      console.error('저장 실패:', error);
      alert('서버 저장에 실패했습니다. 브라우저에만 저장됩니다.');
      localStorage.setItem('siteConfig', JSON.stringify(config));
    }
  };

  const addTab = () => {
    const newTab = {
      id: `tab_${Date.now()}`,
      label: '새 탭',
      path: `/tab_${Date.now()}`,
      title: '새 페이지',
      description: ['페이지 설명을 입력하세요.'],
      visible: true,
      blocks: [],
    };
    setConfig({ ...config, tabs: [...config.tabs, newTab] });
  };

  const deleteTab = (index) => {
    if (window.confirm('이 탭을 삭제하시겠습니까?')) {
      const newTabs = config.tabs.filter((_, i) => i !== index);
      setConfig({ ...config, tabs: newTabs });
    }
  };

  const toggleTabVisibility = (index) => {
    const newTabs = [...config.tabs];
    newTabs[index].visible = !newTabs[index].visible;
    setConfig({ ...config, tabs: newTabs });
  };

  const updateTab = (index, field, value) => {
    const newTabs = [...config.tabs];
    if (field === 'description') {
      newTabs[index][field] = value.split('\n');
    } else {
      newTabs[index][field] = value;
    }
    setConfig({ ...config, tabs: newTabs });
  };

  const addBlock = (tabIndex) => {
    const newTabs = [...config.tabs];
    newTabs[tabIndex].blocks.push({
      subtitle: '새 블록',
      cards: [],
    });
    setConfig({ ...config, tabs: newTabs });
  };

  const deleteBlock = (tabIndex, blockIndex) => {
    if (window.confirm('이 블록을 삭제하시겠습니까?')) {
      const newTabs = [...config.tabs];
      newTabs[tabIndex].blocks = newTabs[tabIndex].blocks.filter((_, i) => i !== blockIndex);
      setConfig({ ...config, tabs: newTabs });
    }
  };

  const updateBlock = (tabIndex, blockIndex, field, value) => {
    const newTabs = [...config.tabs];
    newTabs[tabIndex].blocks[blockIndex][field] = value;
    setConfig({ ...config, tabs: newTabs });
  };

  const addCard = (tabIndex, blockIndex) => {
    const newTabs = [...config.tabs];
    newTabs[tabIndex].blocks[blockIndex].cards.push({
      emoji: '✨',
      title: '새 카드',
      description: '설명을 입력하세요',
      link: 'https://example.com',
      bgColor: '#74b9ff',
      bgImage: '',
    });
    setConfig({ ...config, tabs: newTabs });
  };

  const deleteCard = (tabIndex, blockIndex, cardIndex) => {
    if (window.confirm('이 카드를 삭제하시겠습니까?')) {
      const newTabs = [...config.tabs];
      newTabs[tabIndex].blocks[blockIndex].cards = newTabs[tabIndex].blocks[blockIndex].cards.filter((_, i) => i !== cardIndex);
      setConfig({ ...config, tabs: newTabs });
    }
  };

  const updateCard = (tabIndex, blockIndex, cardIndex, field, value) => {
    const newTabs = [...config.tabs];
    newTabs[tabIndex].blocks[blockIndex].cards[cardIndex][field] = value;
    setConfig({ ...config, tabs: newTabs });
  };

  // 비밀번호 입력 화면
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <h1 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            🔐 관리자 페이지
          </h1>
          <form onSubmit={handlePasswordSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                비밀번호 입력
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                autoFocus
              />
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 mb-3"
            >
              로그인
            </button>
            <button
              type="button"
              onClick={() => navigate('/')}
              className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
            >
              취소
            </button>
          </form>
          <p className="text-xs text-gray-500 mt-4 text-center">
            기본 비밀번호: mcp1234
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* 헤더 */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">⚙️ 관리자 페이지</h1>
            <div className="flex gap-2">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                💾 저장
              </button>
              <button
                onClick={handleResetPassword}
                className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700"
                title="비밀번호 재설정"
              >
                🔑
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                🚪 로그아웃
              </button>
            </div>
          </div>

          {/* 사이트 제목 설정 */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              사이트 제목
            </label>
            <input
              type="text"
              value={config.siteTitle}
              onChange={(e) => setConfig({ ...config, siteTitle: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          {/* 애드센스 코드 */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              구글 애드센스 클라이언트 ID (예: ca-pub-1234567890)
            </label>
            <input
              type="text"
              value={config.adsenseCode}
              onChange={(e) => setConfig({ ...config, adsenseCode: e.target.value })}
              placeholder="ca-pub-1234567890"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
            <p className="text-xs text-gray-500 mt-1">비워두면 광고가 표시되지 않습니다</p>
          </div>
        </div>

        {/* 탭 관리 */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-900">📑 탭 관리</h2>
            <button
              onClick={addTab}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
            >
              ➕ 탭 추가
            </button>
          </div>

          {config.tabs.map((tab, tabIndex) => (
            <div key={tab.id} className="border border-gray-300 rounded-lg p-4 mb-4">
              {/* 탭 기본 정보 */}
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                  <div className="grid grid-cols-2 gap-4 mb-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">탭 라벨</label>
                      <input
                        type="text"
                        value={tab.label}
                        onChange={(e) => updateTab(tabIndex, 'label', e.target.value)}
                        className="w-full px-3 py-1.5 border border-gray-300 rounded"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">경로</label>
                      <input
                        type="text"
                        value={tab.path}
                        onChange={(e) => updateTab(tabIndex, 'path', e.target.value)}
                        className="w-full px-3 py-1.5 border border-gray-300 rounded"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">페이지 제목</label>
                    <input
                      type="text"
                      value={tab.title}
                      onChange={(e) => updateTab(tabIndex, 'title', e.target.value)}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">페이지 설명 (줄바꿈으로 구분)</label>
                    <textarea
                      value={tab.description.join('\n')}
                      onChange={(e) => updateTab(tabIndex, 'description', e.target.value)}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded"
                      rows="2"
                    />
                  </div>
                </div>
                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => toggleTabVisibility(tabIndex)}
                    className={`px-3 py-1.5 rounded ${tab.visible ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}
                  >
                    {tab.visible ? '👁️ 표시' : '🚫 숨김'}
                  </button>
                  <button
                    onClick={() => deleteTab(tabIndex)}
                    className="px-3 py-1.5 bg-red-100 text-red-700 rounded hover:bg-red-200"
                  >
                    🗑️
                  </button>
                </div>
              </div>

              {/* 블록 관리 */}
              <div className="ml-4 border-l-2 border-gray-200 pl-4">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-sm font-semibold text-gray-700">카드 블록</h3>
                  <button
                    onClick={() => addBlock(tabIndex)}
                    className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
                  >
                    ➕ 블록 추가
                  </button>
                </div>

                {tab.blocks.map((block, blockIndex) => (
                  <div key={blockIndex} className="bg-gray-50 rounded p-3 mb-3">
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">블록 제목</label>
                        <input
                          type="text"
                          value={block.subtitle}
                          onChange={(e) => updateBlock(tabIndex, blockIndex, 'subtitle', e.target.value)}
                          className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                        />
                      </div>
                      <button
                        onClick={() => deleteBlock(tabIndex, blockIndex)}
                        className="px-2 py-1 bg-red-100 text-red-700 rounded text-sm ml-2 hover:bg-red-200"
                      >
                        🗑️
                      </button>
                    </div>

                    {/* 카드 관리 */}
                    <div className="ml-4 space-y-2">
                      <div className="flex justify-between items-center">
                        <h4 className="text-xs font-semibold text-gray-600">카드 목록</h4>
                        <button
                          onClick={() => addCard(tabIndex, blockIndex)}
                          className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs hover:bg-purple-200"
                        >
                          ➕ 카드
                        </button>
                      </div>

                      {block.cards.map((card, cardIndex) => (
                        <div key={cardIndex} className="bg-white rounded p-2 border border-gray-200">
                          <div className="grid grid-cols-2 gap-2">
                            <div>
                              <label className="block text-xs text-gray-500">이모지</label>
                              <input
                                type="text"
                                value={card.emoji}
                                onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'emoji', e.target.value)}
                                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-500">배경색</label>
                              <input
                                type="color"
                                value={card.bgColor}
                                onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'bgColor', e.target.value)}
                                className="w-full h-8 border border-gray-300 rounded"
                              />
                            </div>
                            <div className="col-span-2">
                              <label className="block text-xs text-gray-500">배경 이미지 URL (선택사항)</label>
                              <input
                                type="text"
                                value={card.bgImage || ''}
                                onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'bgImage', e.target.value)}
                                placeholder="https://example.com/image.jpg"
                                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                              />
                            </div>
                            <div className="col-span-2">
                              <label className="block text-xs text-gray-500">제목</label>
                              <input
                                type="text"
                                value={card.title}
                                onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'title', e.target.value)}
                                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                              />
                            </div>
                            <div className="col-span-2">
                              <label className="block text-xs text-gray-500">설명</label>
                              <input
                                type="text"
                                value={card.description}
                                onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'description', e.target.value)}
                                className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                              />
                            </div>
                            <div className="col-span-2">
                              <label className="block text-xs text-gray-500">링크</label>
                              <div className="flex gap-1">
                                <input
                                  type="text"
                                  value={card.link}
                                  onChange={(e) => updateCard(tabIndex, blockIndex, cardIndex, 'link', e.target.value)}
                                  className="flex-1 px-2 py-1 border border-gray-300 rounded text-sm"
                                />
                                <button
                                  onClick={() => deleteCard(tabIndex, blockIndex, cardIndex)}
                                  className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
                                >
                                  🗑️
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
